import {
  EmergencyActionsSection,
  SafetyGuidelinesSection,
  CertificationBadgeSection,
  PreventionSection,
  SafetyResourcesSection,
} from "@features/residential/components";

interface SafetyEmergencyPageProps {
  hero: React.ReactNode;
  footer?: React.ReactNode;
}

export default function SafetyEmergencyPage({ hero, footer }: SafetyEmergencyPageProps) {
  return (
    <div className="w-full flex flex-col bg-white">
      {hero}
      <EmergencyActionsSection />
      <SafetyGuidelinesSection />
      <CertificationBadgeSection />
      <PreventionSection />
      <SafetyResourcesSection />
      {footer}
    </div>
  );
}
